<template>
  <div>
    <div :class="{'c-sidebar__active-group': group === 'events'}">
      <router-link
        class="c-sidebar__item c-sidebar__item-main"
        exact :to="{ name: 'admin.events'}">
        {{$t('events')}}
      </router-link>
    </div>
    <div :class="{'c-sidebar__active-group': group === 'organisations'}">
      <router-link
        class="c-sidebar__item c-sidebar__item-main"
        exact :to="{ name: 'admin.organisations'}">
        {{$t('organisations')}}
      </router-link>
    </div>
    <div :class="{'c-sidebar__active-group': group === 'users'}">
      <router-link
        class="c-sidebar__item c-sidebar__item-main"
        exact :to="{ name: 'admin.users'}">
        {{$t('users')}}
      </router-link>
    </div>
    <div :class="{'c-sidebar__active-group': group === 'invoicing'}">
      <router-link
        class="c-sidebar__item c-sidebar__item-main"
        exact :to="{ name: 'admin.invoicing'}">
        {{$t('Invoicing')}}
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'home-menu',
    data: function() {
      return {
        group: 'events',
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler: function(to) {
          const path = to.path;
          if (path.startsWith('/admin/organisations')) {
            this.group = 'organisations'
          } else if (path.startsWith('/admin/users')) {
            this.group = 'users'
          } else if (path.startsWith('/admin/invoicing')) {
            this.group = 'invoicing'
          } else {
            this.group = 'events'
          }
        },
      },
    },
  }
</script>
